const ParentDashboardTypes = {
	ADD_CHILD_DETAILS: {
		SUCCESS: 'ADD_CHILD_DETAILS_SUCCESS',
		FAILURE: 'ADD_CHILD_DETAILS_FAILURE',
		PENDING: 'ADD_CHILD_DETAILS_PENDING',
	},

	EDIT_CHILD_DETAILS: {
		SUCCESS: 'EDIT_CHILD_DETAILS_SUCCESS',
		FAILURE: 'EDIT_CHILD_DETAILS_FAILURE',
		PENDING: 'EDIT_CHILD_DETAILS_PENDING',
	},

	GET_CHILDREN_LIST: {
		SUCCESS: 'GET_CHILDREN_LIST_SUCCESS',
		FAILURE: 'GET_CHILDREN_LIST_FAILURE',
		PENDING: 'GET_CHILDREN_LIST_PENDING',
	},

	GET_CHILD_TOKEN: {
		SUCCESS: 'GET_CHILD_TOKEN_SUCCESS',
		FAILURE: 'GET_CHILD_TOKEN_FAILURE',
		PENDING: 'GET_CHILD_TOKEN_PENDING',
	},

	GET_CHILD_COURSE: {
		SUCCESS: 'GET_CHILD_COURSE_SUCCESS',
		FAILURE: 'GET_CHILD_COURSE_FAILURE',
		PENDING: 'GET_CHILD_COURSE_PENDING',
	},
	GET_CHILD_SPEECH_COURSE: {
		SUCCESS: ' GET_CHILD__SPEECH_COURSE_SUCCESS',
		FAILURE: ' GET_CHILD__SPEECH_COURSE_FAILURE',
		PENDING: ' GET_CHILD__SPEECH_COURSE_PENDING',
	},

	UPDATE_PARENT_NAME: {
		SUCCESS: 'UPDATE_PARENT_NAME_SUCCESS',
		FAILURE: 'UPDATE_PARENT_NAME_FAILURE',
		PENDING: 'UPDATE_PARENT_NAME_PENDING',
	},

	GET_PRODUCT_DETAILS_CHILD: {
		SUCCESS: 'GET_PRODUCT_DETAILS_CHILD_SUCCESS',
		FAILURE: 'GET_PRODUCT_DETAILS_CHILD_FAILURE',
		PENDING: 'GET_PRODUCT_DETAILS_CHILD_PENDING',
	},
	GENERATE_CHILD_REPORT: {
		SUCCESS: 'GENERATE_CHILD_REPORT_SUCCESS',
		FAILURE: 'GENERATE_CHILD_REPORT_FAILURE',
		PENDING: 'GENERATE_CHILD_REPORT_PENDING',
	},
	APPLY_LICENSE: {
		SUCCESS: 'APPLY_LICENSE_SUCCESS',
		FAILURE: 'APPLY_LICENSE_FAILURE',
		PENDING: 'APPLY_LICENSE_PENDING',
	},
	GET_CHILD_DETAILS: {
		SUCCESS: 'GET_CHILD_DETAILS_SUCCESS',
		FAILURE: 'GET_CHILD_DETAILS_FAILURE',
		PENDING: 'GET_CHILD_DETAILS_PENDING',
	},
	SET_ACTIVE_CHILD: 'SET_ACTIVE_CHILD',
	SHOW_ADD_CHILD: 'SHOW_ADD_CHILD',
	SHOW_EDIT_CHILD: 'SHOW_EDIT_CHILD',
	SET_EDIT_CHILD_DETAILS: 'SET_EDIT_CHILD_DETAILS',
	RESET_TOKEN: 'RESET_TOKEN',
	SET_HAS_LICENSE: 'SET_HAS_LICENSE',
};

export default ParentDashboardTypes;
